import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import config from 'config';
import { useDispatch, useSelector } from 'react-redux';
import { getInitialMiddleware, createBentoAction, createAction, createCachedSelector, createReducer, outOfDateStatus, startLoading, stopLoading, upToDateStatus, configureRTKStore } from '@techstyle/redux-core';
import { OrderDetailError } from './schema';
export var initiateReturnRequest = createAction('accounts/initiateReturnRequest');
export var initiateReturnSuccess = createAction('accounts/initiateReturnSuccess');
export var initiateReturnFailure = createAction('accounts/initiateReturnFailure');
export function initiateReturn(returnData) {
  return {
    bentoApi: {
      method: 'POST',
      endpoint: "accounts/me/orders/".concat(returnData.orderId, "/rmas"),
      json: returnData,
      actions: [initiateReturnRequest, initiateReturnSuccess, initiateReturnFailure]
    }
  };
}
/* ------------------------------------
 * Order Details Reducer
 * ------------------------------------ */

export var initialOrderDetailsState = {};
export var loadOrderDetailsRequest = createAction('accounts/loadOrderDetailsRequest');
export var loadOrderDetailsSuccess = createAction('accounts/loadOrderDetailsSuccess');
export var loadOrderDetailsFailure = createAction('accounts/loadOrderDetailsFailure');
export var invalidateOrderDetailsAction = createAction('accounts/invalidateOrderDetails');
export var orderDetailsReducer = createReducer(initialOrderDetailsState, (_createReducer = {}, _defineProperty(_createReducer, loadOrderDetailsRequest.type, function (state, action) {
  if (!state[action.meta.orderId]) {
    state[action.meta.orderId] = {
      networkStatus: outOfDateStatus()
    };
  }

  startLoading(state[action.meta.orderId]);
}), _defineProperty(_createReducer, loadOrderDetailsFailure.type, function (state, action) {
  if (!state[action.meta.orderId]) {
    state[action.meta.orderId] = {
      networkStatus: outOfDateStatus()
    };
  }

  state[action.meta.orderId].error = OrderDetailError.OTHER;
  state[action.meta.orderId].fetchedDate = action.meta.fetchedDate;
  stopLoading(state[action.meta.orderId]);
}), _defineProperty(_createReducer, loadOrderDetailsSuccess.type, function (state, action) {
  var result = action.payload;
  state[result.orderId] = {
    data: result,
    fetchedDate: action.meta.fetchedDate,
    error: null,
    networkStatus: upToDateStatus()
  };
}), _defineProperty(_createReducer, invalidateOrderDetailsAction.type, function (state, action) {
  if (state[action.payload.orderId]) {
    state[action.payload.orderId].networkStatus = outOfDateStatus();
  }
}), _defineProperty(_createReducer, initiateReturnSuccess.type, function (state, action) {
  var _action$meta, _action$meta$fetchOpt, _action$meta$fetchOpt2;

  var orderId = action === null || action === void 0 ? void 0 : (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : (_action$meta$fetchOpt = _action$meta.fetchOptions) === null || _action$meta$fetchOpt === void 0 ? void 0 : (_action$meta$fetchOpt2 = _action$meta$fetchOpt.json) === null || _action$meta$fetchOpt2 === void 0 ? void 0 : _action$meta$fetchOpt2.orderId;

  if (state[orderId]) {
    state[orderId].networkStatus = outOfDateStatus();
  }
}), _createReducer));
export var invalidateOrderDetails = function invalidateOrderDetails(orderId) {
  return invalidateOrderDetailsAction({
    orderId: orderId
  }, {});
};
/* ------------------------------------
 * Return Settings Reducer
 * ------------------------------------ */

export var initialReturnSettingsState = {
  networkStatus: outOfDateStatus(),
  settings: null
};
export var loadReturnSettingsRequest = createAction('accounts/loadReturnSettingsRequest');
export var loadReturnSettingsSuccess = createAction('accounts/loadReturnSettingsSuccess');
export var loadReturnSettingsFailure = createAction('accounts/loadReturnSettingsFailure');
export var returnSettingsReducer = createReducer(initialReturnSettingsState, function (builder) {
  return builder.addCase(loadReturnSettingsRequest, startLoading).addCase(loadReturnSettingsFailure, stopLoading).addCase(loadReturnSettingsSuccess, function (state, action) {
    var result = action.payload;
    state.settings = result;
    state.networkStatus = upToDateStatus();
  });
});
/* ------------------------------------
 * Typed Module Helpers
 * ------------------------------------ */

function createStore() {
  return configureRTKStore({
    reducer: {
      orderDetails: orderDetailsReducer,
      returnSettings: returnSettingsReducer
    },
    middleware: getInitialMiddleware()
  });
}

export var useModuleSelector = useSelector;
export var useModuleDispatch = useDispatch;
/* ------------------------------------
 * Actions
 * ------------------------------------ */

export function loadOrderDetails(orderId) {
  return function (dispatch, getState) {
    var state = getState().orderDetails;
    var order = state[orderId];
    var shouldFetch = false;

    if (order) {
      if (order.networkStatus.isLoading) {// Already loading, do nothing.
      } else if (!order.networkStatus.isUpToDate) {
        shouldFetch = true;
      }
    } else {
      shouldFetch = true;
    }

    if (shouldFetch) {
      return dispatch(createBentoAction({
        endpoint: "accounts/me/orders/".concat(orderId),
        requestKey: JSON.stringify(['loadOrderDetails', orderId]),
        actions: [function (payload, meta) {
          return loadOrderDetailsRequest(payload, _objectSpread(_objectSpread({}, meta), {}, {
            orderId: orderId
          }));
        }, function (payload, meta) {
          return loadOrderDetailsSuccess(payload, _objectSpread(_objectSpread({}, meta), {}, {
            orderId: orderId
          }));
        }, function (payload, meta) {
          return loadOrderDetailsFailure(payload, _objectSpread(_objectSpread({}, meta), {}, {
            orderId: orderId
          }));
        }]
      }));
    }
  };
}
export var loadOrdersRequest = createAction('accounts/loadOrdersRequest');
export var loadOrdersSuccess = createAction('accounts/loadOrdersSuccess');
export var loadOrdersFailure = createAction('accounts/loadOrdersFailure'); // The API currently accepts -1,0 and 1 as options for the status filter.
// Corresponding to "all" (-1), "non-shipped" (0) and "shipped" (1) orders

export var ShippingStatusFilter;

(function (ShippingStatusFilter) {
  ShippingStatusFilter[ShippingStatusFilter["All"] = -1] = "All";
  ShippingStatusFilter[ShippingStatusFilter["Pending"] = 0] = "Pending";
  ShippingStatusFilter[ShippingStatusFilter["Shipped"] = 1] = "Shipped";
})(ShippingStatusFilter || (ShippingStatusFilter = {}));

export function loadOrders() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? config.get('public.orders.pageSize') : _ref$pageSize,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? 'DESC' : _ref$sort,
      dateExpectedMin = _ref.dateExpectedMin,
      dateExpectedMax = _ref.dateExpectedMax,
      _ref$orderStatusFilte = _ref.orderStatusFilter,
      orderStatusFilter = _ref$orderStatusFilte === void 0 ? ShippingStatusFilter.All : _ref$orderStatusFilte,
      excludeOrderTypeIds = _ref.excludeOrderTypeIds;

  return createBentoAction({
    endpoint: 'accounts/me/orders',
    requestKey: JSON.stringify(['orders', page, pageSize, sort]),
    searchParams: {
      pageIndex: page,
      recordsPerPage: pageSize,
      order: sort,
      shipped: orderStatusFilter,
      excludeOrderTypeIds: excludeOrderTypeIds === null || excludeOrderTypeIds === void 0 ? void 0 : excludeOrderTypeIds.toString(),
      dateExpectedMin: dateExpectedMin === null || dateExpectedMin === void 0 ? void 0 : dateExpectedMin.toISOString(),
      dateExpectedMax: dateExpectedMax === null || dateExpectedMax === void 0 ? void 0 : dateExpectedMax.toISOString()
    },
    actions: [loadOrdersRequest, loadOrdersSuccess, loadOrdersFailure]
  });
}
export function loadReturnSettings() {
  return createBentoAction({
    endpoint: 'settings/returns',
    requestKey: 'loadReturnSettings',
    actions: [loadReturnSettingsRequest, loadReturnSettingsSuccess, loadReturnSettingsFailure]
  });
}
export var loadRMADetailsRequest = createAction('accounts/loadRMADetailsRequest');
export var loadRMADetailsSuccess = createAction('accounts/loadRMADetailsSuccess');
export var loadRMADetailsFailure = createAction('accounts/loadRMADetailsFailure');
export function loadRMADetails(_ref2) {
  var rmaId = _ref2.rmaId,
      _ref2$includeExchange = _ref2.includeExchange,
      includeExchange = _ref2$includeExchange === void 0 ? false : _ref2$includeExchange;
  var endpoint = "accounts/me/orders/rma/".concat(rmaId).concat(includeExchange ? '?includeExchange=true' : '');
  return createBentoAction({
    endpoint: endpoint,
    method: 'GET',
    requestKey: "loadRMADetails:".concat(endpoint),
    actions: [loadRMADetailsRequest, loadRMADetailsSuccess, loadRMADetailsFailure]
  });
}
/* ------------------------------------
 * Selectors
 * ------------------------------------ */

export var getOrderById = createCachedSelector([function (state, orderId) {
  return state.orderDetails[orderId];
}, function (state, orderId) {
  return orderId;
}], function (orderDetails, orderId) {
  return orderDetails ? _objectSpread(_objectSpread({}, orderDetails), {}, {
    orderId: orderId
  }) : {
    orderId: orderId,
    fetchedDate: null,
    networkStatus: outOfDateStatus()
  };
})(function (state, orderId) {
  return orderId;
}); // Loyalty History

export var loadLoyaltyHistoryRequest = createAction('accounts/loadLoyaltyHistoryRequest');
export var loadLoyaltyHistorySuccess = createAction('accounts/loadLoyaltyHistorySuccess');
export var loadLoyaltyHistoryFailure = createAction('accounts/loadLoyaltyHistoryFailure');
export function loadLoyaltyHistory() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$page = _ref3.page,
      page = _ref3$page === void 0 ? 1 : _ref3$page,
      _ref3$count = _ref3.count,
      count = _ref3$count === void 0 ? 3 : _ref3$count;

  return createBentoAction({
    endpoint: 'accounts/me/loyalty/history',
    requestKey: JSON.stringify(['loadLoyaltyHistory', page, count]),
    searchParams: {
      page: page,
      count: count
    },
    actions: [loadLoyaltyHistoryRequest, loadLoyaltyHistorySuccess, loadLoyaltyHistoryFailure]
  });
}